var paymentMethodTypes = {
  APPLE_PAY: 'applePay',
  APPLE_PAY_EXPRESS: 'applePayExpress',
  CARD: 'card',
  EXPRESS_ELIGIBLE: 'expressEligible',
  GOOGLE_PAY: 'googlePay'
};
export { paymentMethodTypes as default };